import type { AllRouteEndpoints } from "../routeTypes";
export const appsAppIdUploadPushCertificateCacheKeys: AllRouteEndpoints[] = [
  "/apps/:app_id/push_credential",
  "/apps/aggregate_push_credential_info",
];
